import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const BusRoutesListView = lazy(() => import('src/pages/bus-route/list'));
const BusRouteDetailsPage = lazy(() => import('src/pages/bus-route/details'));

// ----------------------------------------------------------------------

const guardedBusRoutesListPage = (
  <RoleBasedGuard navigateTo roles={['transporation.manager', 'transportation.admin']}>
    <BusRoutesListView />
  </RoleBasedGuard>
);

const guardedBusRouteDetailsPage = (
  <RoleBasedGuard navigateTo roles={['transporation.manager', 'transportation.admin']}>
    <BusRouteDetailsPage />
  </RoleBasedGuard>
);

export const busRoutesRoutes = [
  {
    path: 'bus-routes',
    children: [
      { element: guardedBusRoutesListPage, index: true },
      { path: ':routeId', element: guardedBusRouteDetailsPage },
    ],
  },
];
